import { ButtonProps } from '@mui/material';
import { StyledButton, ButtonInner, Spinner } from './ButtonWithSpinner.styles';

interface ButtonWithSpinnerProps extends ButtonProps {
  showSpinner: boolean;
}

const ButtonWithSpinner = ({ children, showSpinner, ...rest }: ButtonWithSpinnerProps) => (
  <StyledButton {...rest}>
    <ButtonInner>
      {showSpinner && <Spinner />}
      {children}
    </ButtonInner>
  </StyledButton>
);

export default ButtonWithSpinner;
